import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useAdminStatus } from '../hooks/useAdminStatus';

interface AdminRouteProps {
  children: React.ReactNode;
}

export default function AdminRoute({ children }: AdminRouteProps) {
  const { user, loading, isConfigured } = useAuth();
  const location = useLocation();
  const status = useAdminStatus();

  if (!isConfigured) return <>{children}</>;
  if (loading) return <LoadingSpinner />;
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;

  if (status === 'checking') return <LoadingSpinner />;
  if (status === 'denied') return <AccessDenied />;

  return <>{children}</>;
}

function LoadingSpinner() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-spotify-black">
      <div className="text-center">
        <div className="w-12 h-12 border-2 border-spotify-green border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-spotify-gray-400">Checking access...</p>
      </div>
    </div>
  );
}

function AccessDenied() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-spotify-black">
      <div className="text-center max-w-md">
        <div className="w-16 h-16 bg-red-500/10 rounded-2xl flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-red-400" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
          </svg>
        </div>
        <h2 className="text-xl font-display font-bold text-white mb-2">Access Denied</h2>
        <p className="text-spotify-gray-400">You don't have admin privileges. Contact your organisation administrator.</p>
      </div>
    </div>
  );
}
